
import BasePageMixin from '~/mixins/base-page-mixin';

// only load ui goodies in the browser
if (process.browser) {
  window.dataLayer = window.dataLayer || [];
  window.bannersJs = window.bannersJs || [];
}

export default {
  mixins: [BasePageMixin],
};
